import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../Auth'
import { jwtDecode } from 'jwt-decode'
import { requestGet } from '../../Helpers'
import { Card } from './Components/Card'

export const MyShopping = () => {

    const {user} = useContext(AuthContext)

    const [shopping, setShopping] = useState([])

    useEffect(() => {
        try {
            const decoded = jwtDecode(user.token)

            console.log('decoded', decoded?.user_id)

            getAllShopping(decoded?.user_id)

        } catch (error) {
            console.log(error);
        }
    }, [user])

    const getAllShopping = (user_id) => {
        requestGet(`orders/?user=${user_id}`)
            .then((data) => {
                setShopping(data || [])
            })
    }

    return (
        <div className='container'>

            <h1 className='text-center'>Mis compras</h1>

            <div className='row'>
                <div className='col-12 col-md-6'>
                    <Card
                        title={'Orden'}
                        date={'Fecha'}
                        price={'Total'}
                        status={'Estado'}
                        updated_at={'Actualizado'}
                    />
                </div>
                
                {
                    shopping?.results?.map((item) => {
                        return (
                            <div className='col-12 col-md-6'>
                                <Card
                                    key={item.id}
                                    order_id={item.order_id}
                                    total={item.total}
                                    status={item.status}
                                    created_at={item.created_at}
                                />
                            </div>
                        )
                    } ) 
                }
            </div>
        
        </div>
    )
}
